a.ui = (function(){
	var my = {
		
	}
	return my;
}());